export default "__VITE_ASSET__ac702b6a__"